export default "/assets/images/graph-dust.0139f91b0b2a3780.png";